// Copyright (c) 2022 by Move Closer§

/**
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
export const FALLBACK_IMG_BASE64 = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII='
export const FALLBACK_LOADER = '/img/placeholder.png'
